import { DownloadSecurityContainerWebComponent } from './component/DownloadSecurityContainerWebComponent';
import { WEB_COMPONENT_DOWNLOAD_SECURITY_CONTAINER } from '../../webcomponents.constants';

export { DownloadSecurityContainerWebComponent };

window.customElements.define(WEB_COMPONENT_DOWNLOAD_SECURITY_CONTAINER, DownloadSecurityContainerWebComponent);
